import { render } from "./MinifyChartsContainer.vue?vue&type=template&id=996a572c&scoped=true"
import script from "./MinifyChartsContainer.vue?vue&type=script&lang=js"
export * from "./MinifyChartsContainer.vue?vue&type=script&lang=js"

import "./MinifyChartsContainer.vue?vue&type=style&index=0&id=996a572c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-996a572c"]])

export default __exports__